import { render, staticRenderFns } from "./AreaView.vue?vue&type=template&id=08231739&scoped=true"
import script from "./AreaView.vue?vue&type=script&lang=js"
export * from "./AreaView.vue?vue&type=script&lang=js"
import style0 from "./AreaView.vue?vue&type=style&index=0&id=08231739&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08231739",
  null
  
)

export default component.exports